import React from 'react';
import TestimonialCard from './TestimonialCard';
import {  Col, Row } from 'reactstrap';
import ProgressCard from './ProgressCard';

const DeveloperProfile = () => {
  return (
    <>
      <Col xl='4' md='6' className='box-col-4'>
        <Row>
          <TestimonialCard />
          <ProgressCard />
        </Row>
      </Col>
    </>
  );
};
export default DeveloperProfile;
